<ng-container *ngIf="{ logoPath: logoPath$ | async, isHomePage: isHomePage$ | async } as data">
    <ng-container *ngIf="theme === 'DARK'; else logoLight">
        <md-icon class="icon-dark" classes="w-100" [name]="data.isHomePage ? data.logoPath['icon-dark'] ?? 'md-logo' : 'md-logo'"></md-icon>
    </ng-container>

    <ng-template #logoLight>
        <md-icon
            class="icon-light"
            classes="w-100"
            [name]="data.isHomePage ? data.logoPath['icon-light'] ?? 'md-logo-white' : 'md-logo-white'"
        ></md-icon>
    </ng-template>
</ng-container>
